$( ".opcion1" ).addClass( "active" );
$( "#opcion1" ).addClass( "menu-active" );
$( "#opcion1 .img1").removeClass( "banner-on" );
$( "#opcion1 .img1").addClass( "banner-off" );
$( "#opcion1 .img2").addClass( "banner-on" );
$( "#opcion1 .img2").removeClass( "banner-off" );
// $('.titulo-ofertas').css('padding-left', '17%');

optionActive = 'opcion1';
count_old = 0;

$('.item-menu-ofertas').on('click', function (e) {
   
  if(optionActive != $(this).attr('id') && $(this).attr('id') !== undefined && $(this).attr('id') != 'opcion5' ){
    
    $( "." + optionActive).removeClass( "active" );
  	$( "." + $(this).attr('id')).addClass( "active" );
    
    $( "#" + optionActive).removeClass( "menu-active" );
  	$( "#" + $(this).attr('id')).addClass( "menu-active" );
    
    $( "#" + optionActive + ' .img2').removeClass( "banner-on" );
    $( "#" + optionActive + ' .img2').addClass( "banner-off" );
    
    $( "#" + optionActive + ' .img1').addClass( "banner-on" );
    $( "#" + optionActive + ' .img1').removeClass( "banner-off" );
    
  	$( "#" + $(this).attr('id') + ' .img1').removeClass( "banner-on" );
    $( "#" + $(this).attr('id') + ' .img1').addClass( "banner-off" );
    
    $( "#" + $(this).attr('id') + ' .img2').removeClass( "banner-off" );
    $( "#" + $(this).attr('id') + ' .img2').addClass( "banner-on" );
    
    let regex = /(\d+)/g;
    
    count = $('#count_menu').val();
    console.log(count);
    pos = $(this).attr('id').match(regex);
    console.log(pos);
    
    if($(this).attr('id') == 'opcion1'){
      $('.titulo-ofertas').css('padding-left', '0');
    }else{
      count = (100/(count-2)) * pos[0];
      if(screen.width < 1024){
       $('.titulo-ofertas').css('padding-left', 'calc('+count+'% - '+$('.titulo-ofertas').width()+'px)');
      }else{
         $('.titulo-ofertas').css('padding-left', 'calc('+count+'% - ' +$('.titulo-ofertas').width()+'px)');
      }
    }

    console.log(count);
    console.log($(this).attr('id'));
    console.log(pos[0]);
    
    optionActive = $(this).attr('id');
       
  }
});